import React, { PropsWithChildren, useEffect } from 'react';
import { useDragLayer } from 'react-dnd';

import { DndProvider } from '@app/src/common/components/dnd/DndProvider';
import { TouchBackend } from 'react-dnd-touch-backend';

const DisableUserSelection = ({ children }: PropsWithChildren<{}>) => {
  const { isDragging } = useDragLayer(monitor => ({
    isDragging: monitor.isDragging()
  }));

  useEffect(() => {
    if (isDragging) {
      document.documentElement.style.userSelect = 'none';
    } else {
      document.documentElement.style.userSelect = '';
    }
  }, [isDragging]);

  return <>{children}</>;
};

const DndContainer = ({ children }: PropsWithChildren<{}>) => (
  <DndProvider backend={TouchBackend} options={{ enableMouseEvents: true }}>
    <DisableUserSelection>{children}</DisableUserSelection>
  </DndProvider>
);

export default DndContainer;
